import React from "react";
import { Dialog } from "@material-ui/core";
import { StyledPaper } from "../contractStatusReportIssuing/styles";
import { FormTitle } from "../../../homePage/styles";
import { FunctionalButton } from "../../../../components/functionalButton";
import PledgxLogo from "../../../../assets/common/pledgxLogo";
import { CloseButton } from "../../../dashboard/styles";
import CloseIcon from "@material-ui/icons/Close"; 

type ImportPopupProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    handleImportExcel: () => void;
    handleImportFromCSV: () => void;
    handleImportFromImagePDF: () => void;
}

export const ImportPopup = ({ open, setOpen, handleImportExcel, handleImportFromCSV, handleImportFromImagePDF }: ImportPopupProps) => (
    <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="import popup"
        aria-describedby="dialog to import data"
        maxWidth="md"
        TransitionComponent={React.Fragment}
    >
        <StyledPaper elevation={0} style={{ width: "500px" }}>
            <CloseButton onClick={() => setOpen(false)} aria-label="close">
                <CloseIcon />
            </CloseButton>
            <PledgxLogo width="60" height="60" />
            <FormTitle style={{ paddingTop: "18px" }}>Import Data</FormTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
                padding: "20px 0 20px",
              }}
            >
                <FunctionalButton
                    buttonTitle="Import from Excel"
                    handleButton={handleImportExcel}
                    width="308px"
                    height="48px"
                    isReversedColor={false}
                    marginRight="48px"
                    marginLeft="48px"
                    marginTop="50px"
                    marginBottom="20px"
                    fontSize="18px"
                    disabled={false}
                    icon={null}
                    hasBoxShadow={true}
                    frontIcon={null}
                    weight={600}
                    borderColor=""
                    selected={false}
                    preserveCase
                />
                <FunctionalButton
                    buttonTitle="Import from CSV" 
                    handleButton={handleImportFromCSV}
                    width="308px"
                    height="48px"
                    isReversedColor={false}
                    marginRight="48px"
                    marginLeft="48px"
                    marginTop="10px"
                    marginBottom="20px"
                    fontSize="18px"
                    disabled={false}
                    icon={null}
                    hasBoxShadow={true}
                    frontIcon={null}
                    weight={600}
                    borderColor=""
                    selected={false}
                    preserveCase
                />
                <FunctionalButton
                    buttonTitle="Import from Image/PDF"
                    handleButton={handleImportFromImagePDF}
                    width="308px"
                    height="48px"
                    isReversedColor={false}
                    marginRight="48px"
                    marginLeft="48px"
                    marginTop="10px"
                    marginBottom="20px"
                    fontSize="18px"
                    disabled={false}
                    icon={null}
                    hasBoxShadow={true}
                    frontIcon={null}
                    weight={600}
                    borderColor=""
                    selected={false}
                    preserveCase
                />
            </div>
        </StyledPaper>
    </Dialog>
)